module.exports = __webpack_public_path__ + "static/Nix-9b806f305b506804a42a7fa83befa935.png";